const PropTypes = require('prop-types');
// @ vendors
const React = require('react');

// @ commons
const { formatText } = require('core/i18n').i18n;

// @ components
const { OKBoxTitle } = require('commonsComponents/OKBoxTitle');
const MortgageRequestFormattedAddress = require('components/mortgageRequest/mortgageRequestEstates/mortgageRequestEstatesData/mortgageRequestFormattedAddress/mortgageRequestFormattedAddress');

// @ constants
const { ESTATES_TYPE } = require('constants/mortgageRequestHolderData');

class MortgageRequestSimpleNoteList extends React.Component {
    render() {
        const { inmueblesList } = this.props;
        const InmuebleList = (
            <div>
                {inmueblesList.map(item => {
                    const estateType = item.get('tipoBien') === ESTATES_TYPE.VIVIENDA ?
                        formatText('mortgageRequestSimpleNote-livingPlace') :
                        item.get('tipoBien') === ESTATES_TYPE.TRASTERO ?
                            formatText('mortgageRequestSimpleNote-storageRoom') :
                            formatText('mortgageRequestSimpleNote-garage');

                    return (
                        <div
                            key={item.get('bienId')}
                            className="mortgage-request-simple-note-result-view__item"
                        >
                            <div className="mortgage-request-simple-note-result-view__explantation">
                                <OKBoxTitle
                                    value={formatText('mortgageRequestSimpleNoteResult-explanationTitle')}
                                />
                            </div>

                            <div className="mortgage-request-simple-note-result-view__data">
                                <p className="ok-informative-list-item__title mortgage-request-simple-note-result-view__label">
                                    {formatText('mortgageRequestSimpleNoteResult-udifirLabel')}
                                </p>

                                <p className="ok-informative-list-item__body-text mortgage-request-simple-note-result-view__text">
                                    {item.get('udifir', '')}
                                </p>

                                <p className="ok-informative-list-item__title mortgage-request-simple-note-result-view__label">
                                    {formatText('mortgageRequestSimpleNoteResult-housingDescriptionLabel')}
                                </p>

                                <div className="mortgage-request-simple-note-result-view__description">
                                    <p className="ok-informative-list-item__body-text mortgage-request-simple-note-result-view__description-item-bold">
                                        {formatText('mortgageRequestSimpleNoteResult-typeDescriptionLabel')}
                                        <span className="ok-informative-list-item__body-text mortgage-request-simple-note-result-view__description-item mortgage-request-simple-note-result-view__description--capitalize">
                                            {estateType}
                                        </span>
                                    </p>
                                </div>

                                <div className="mortgage-request-simple-note-result-view__description">
                                    <p className="ok-informative-list-item__body-text mortgage-request-simple-note-result-view__description-item-bold">
                                        {formatText('mortgageRequestSimpleNoteResult-surfaceDescriptionLabel')}
                                        <span className="ok-informative-list-item__body-text mortgage-request-simple-note-result-view__description-item">
                                            {`${item.get('superficieBien', '')} `}{' '}
                                            <span>m&sup2;</span>
                                        </span>
                                    </p>
                                </div>

                                <div className="mortgage-request-simple-note-result-view__description">
                                    <p className="ok-informative-list-item__body-text mortgage-request-simple-note-result-view__description-item-bold">
                                        {formatText('mortgageRequestSimpleNoteResult-addressDescriptionLabel')}
                                        <MortgageRequestFormattedAddress
                                            immEstate={item}
                                            className="ok-informative-list-item__body-text mortgage-request-simple-note-result-view__description-item"
                                            v1
                                        />
                                    </p>
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>
        );

        return InmuebleList;
    }
}

module.exports.constructor = MortgageRequestSimpleNoteList;

MortgageRequestSimpleNoteList.propTypes = {
    inmueblesList: PropTypes.object
};

module.exports = MortgageRequestSimpleNoteList;